define('js/lib/inherits',[],function () {
    'use strict';

    return function inherits(ctor, superCtor) {
        Object.setPrototypeOf(ctor.prototype, superCtor.prototype);
    };
});
